module.exports = __webpack_public_path__ + "img/khfw.4f7d678d.jpg";